import { cn } from '@/lib/utils';

interface PasswordStrengthIndicatorProps {
  strength: number | null;
  compact?: boolean;
}

export function PasswordStrengthIndicator({
  strength,
  compact,
}: PasswordStrengthIndicatorProps) {
  if (strength === null)
    return <span className="text-muted-foreground">Not set</span>;
  const colors = [
    'bg-red-500',
    'bg-red-400',
    'bg-yellow-500',
    'bg-green-400',
    'bg-green-500',
  ];
  return (
    <div className="flex items-center gap-2">
      <div className="flex gap-0.5">
        {[0, 1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className={cn(
              'h-2 w-4 rounded-sm',
              i <= strength ? colors[strength] : 'bg-muted',
            )}
          />
        ))}
      </div>
      {!compact && <span className="text-sm">{strength}/4</span>}
    </div>
  );
}
